<template>
  <div class="d-flex column-gap-1 align-center">
    <ClosdFildersIcon :document="file"/>
    <template v-if="file.numbering">
      <span data-locator="file-numbering">{{ `${file.numbering}` }}</span>
    </template>
    <AppTooltip :disabled="!showTooltip" location="top">
      <template #activator="{ props }">
        <div
          v-bind="props"
          ref="nameElement"
          class="filderName clickable"
          data-locator="file-name"
          @click="onOpenDocument"
          @mouseenter="checkIfTruncated"
        >
          {{ file.basename || file.name }}
        </div>
      </template>
      <span>{{ file.basename || file.name }}</span>
    </AppTooltip>
    <div class="ml-auto">
      <app-badge v-if="isRedactedFile" style="text-transform: inherit;">
        {{ $t('project.documents.table.DocumentsTableItem.isRedacted') }}
      </app-badge>
      <app-badge v-if="file.version > 1" :class="{ 'ml-1': isRedactedFile }">
        {{ `v${file.version}` }}
      </app-badge>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import { getPdfContentType, USER_ROLE, track } from '@/common/pendo/agent'
import { openFileViewer } from '@/common/utils/files'

export default {
  name: 'DocumentsTableItemFileName',
  components: { ClosdFildersIcon, AppTooltip },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showTooltip: false,
    }
  },
  computed: {
    ...mapGetters('room', ['roomMnemo', 'isCurrentUserPm']),
    isRedactedFile () {
      return this.file.isRedacted
    },
  },
  methods: {
    onOpenDocument () {
      track('document_downloaded', {
        document_id: this.file.id,
        project_mnemo: this.roomMnemo,
        user_role: this.isCurrentUserPm ? USER_ROLE.PROJECT_MANAGER : USER_ROLE.GUEST,
        document_type: this.file.ext,
        entrypoint: 'document_list',
        pdf_content_type: getPdfContentType(this.file),
      })
      openFileViewer(this.roomMnemo, this.file.id)
    },
    checkIfTruncated() {
      const el = this.$refs.nameElement
      if (el) {
        this.showTooltip = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkIfTruncated()
    })
  },
}
</script>
